module.exports = __webpack_public_path__ + "static/media/proof-of-address.5ecbffde.svg";